'use client'
import React from 'react';
import Link from 'next/link';
import { Swiper, SwiperSlide } from 'swiper/react';
import useCustomSWR from '@/hook/useCustomSWR';
import { Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { Skeleton } from '@mui/material';
import useDeviceType from '@/hook/useDeviceType';
import { formatDate } from '@/utils/formatDate';
import { v4 as uuidv4 } from 'uuid';
const BlogHeroBanner = () => {
    const deviceType = useDeviceType()
    const { data, isLoading, isError, revalidate } = useCustomSWR(
        `/v1/blog/get/post?isBanner=true`,
        true
    );

    if (!data?.data?.length) {
        return (
            <Swiper
                modules={[Scrollbar, A11y, Autoplay, Pagination]} // Include Autoplay module here
                spaceBetween={50}
                slidesPerView={1}
                pagination={{ clickable: true }}
                // scrollbar={{ draggable: true }}
                autoplay={{ // Add autoplay configuration
                    delay: 6000, // Delay in milliseconds (3 seconds in this case)
                    disableOnInteraction: false, // Keep autoplay active after user interactions
                }}
            >
                {[1, 2].map(d => (
                    <SwiperSlide key={uuidv4()}>
                        <div className={`w-full h-80 md:h-96 lg:h-[85vh]`}>
                            <Skeleton
                                key={d}
                                animation='wave'
                                variant='rectangular'
                                width='100%'
                                height='100%'
                            />
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        );
    }


    return (
        <>
            <div className='h-1  border-gray-300  shadow-mmd'>
            </div>
            <Swiper
                modules={[Scrollbar, A11y, Autoplay, Pagination]} // Include Autoplay module here
                spaceBetween={50}
                slidesPerView={1}
                pagination={{ clickable: true }}
                // scrollbar={{ draggable: true }}
                autoplay={{ // Add autoplay configuration
                    delay: 6000, // Delay in milliseconds (3 seconds in this case)
                    disableOnInteraction: false, // Keep autoplay active after user interactions
                }}
            // onSlideChange={() => console.log('slide change')}
            >
                {
                    data?.data?.map(d => {
                        const banner = deviceType === 'mobile' ? d.mobile_banner : d.main_banner
                        return (
                            <SwiperSlide key={uuidv4()}>
                                <Link href={`/blog/${d.slug}`} className='relative block'>
                                    <img src={banner} alt={d.main_banner_altTag} loading='lazy' className='w-full ' />
                                    <div className='hidden absolute z-10 inset-x-0 bottom-0 p-5 md:flex justify-between items-end gap-2'>
                                        <div className='max-w-xl'>
                                            <div className='hidden md:flex my-2 flex-row flex-wrap gap-1 '>
                                                {d?.tags?.slice(0.3)?.map((d, i) => (
                                                    <button key={i} className='bg-gray-100 text-[8px] sm:text-[10px]  py-1 px-4 rounded-full '>{d}</button>
                                                ))}
                                            </div>
                                            <h2 className='text-base md:text-xl font-bold'>{d.title}</h2>
                                        </div>
                                        <div className='hidden md:block'>
                                            <p className='mb-2 text-sm'>{formatDate(d.updatedAt)}</p>
                                        </div>
                                    </div>
                                    <div className='hidden absolute inset-0 max-md:flex justify-center items-center p-5'>
                                        <h2 className='text-base md:text-xl font-bold text-center'>{d.title}</h2>
                                    </div>
                                </Link>
                            </SwiperSlide>
                        )
                    })
                }
            </Swiper>
        </>
    );
};

export default BlogHeroBanner;
